import { hasValue } from "@itk/typescript-utils";
import numeral from "numeral";

/**
 * @param value The value to be formatted with thousands separator, and propper delimiters depending on locale
 * @returns Returns a string with the value formatted with thousands separator, and propper delimiters.
 */

export const thousandsSeparator = (value: number, locale: "en" | "da-dk" = "en") => {
  numeral.locale(locale);
  const numeralValue = numeral();

  numeralValue.set(value);

  const numeralNumber = numeralValue.value();
  if (hasValue(numeralNumber) && isNaN(numeralNumber)) return "NaN";

  let amountOfDecimalPlaces = 0;
  if (value.toString().includes(".")) amountOfDecimalPlaces = value.toString().split(".")[1].length;
  // and show the correct amount of decimals
  return numeralValue.format(`0,0.[0${"0".repeat(amountOfDecimalPlaces)}]`);
};
